"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.list-container a {\n  color: #000000; }\n\n.list-container li:not(:first-child) {\n  margin-top: 13px; }\n\n.list-container ul li {\n  padding-left: 12px; }\n\n.list-container ul li:before {\n  width: 4px;\n  height: 4px;\n  background-color: #161616;\n  content: '' !important;\n  margin-top: 7px;\n  margin-left: 17px;\n  font-family: 'Helvetica Neue LT Roman'; }\n\n.list-container ol li {\n  padding-left: 16px; }\n\n.list-container ol li:before {\n  margin-top: 2px;\n  margin-left: 24px;\n  font-size: 12px;\n  color: #000000; }\n\n.list-container .unordered .children li {\n  margin-top: 4px; }\n\n.list-container .unordered .children ol {\n  margin-left: 7px; }\n\n.list-container .unordered .children li::marker {\n  content: '' !important; }\n\n.list-container .unordered .children li::before {\n  margin-top: 7px;\n  margin-left: -13px;\n  margin-right: 2px;\n  font-family: 'Helvetica Neue LT Roman'; }\n\n.list-container .ordered .children {\n  margin-left: -11px; }\n  .list-container .ordered .children li {\n    margin-top: 4px; }\n  .list-container .ordered .children ol {\n    margin-left: 7px; }\n  .list-container .ordered .children li::marker {\n    content: '' !important; }\n  .list-container .ordered .children li::before {\n    margin-top: 7px;\n    margin-left: -13px;\n    margin-right: 2px;\n    font-family: 'Helvetica Neue LT Roman'; }\n\n@media (max-width: 42rem) {\n  .list-container .li,\n  .list-container p {\n    max-width: 288px; } }\n";
  const fileName = "List_List";
  const element = document.querySelector("style[data-sass-component='List_List']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const variants = exports.variants = {
  ORDERED: 'ORDERED',
  UNORDERED: 'UNORDERED'
};
const Item = _ref => {
  let {
    content,
    children,
    nested,
    level,
    variant,
    lang
  } = _ref;
  const spanStyle = variant === variants.ORDERED ? {
    paddingLeft: `${13 * (level - 1)}px`
  } : {
    paddingLeft: `${2 * (level - 1)}px`
  };
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.ListItem, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "textWithSyllabification sia-text-10",
    style: spanStyle,
    lang: lang,
    dangerouslySetInnerHTML: {
      __html: `${nested ? '– ' : ''}${content}`
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "children"
  }, children?.length > 0 && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.OrderedList, {
    nested: true
  }, children.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(Item, _extends({
      key: index
    }, item, {
      nested: true,
      level: level + 1,
      variant: variant
    }));
  }))));
};
const List = _ref2 => {
  let {
    title,
    items,
    variant
  } = _ref2;
  const Wrapper = _ref3 => {
    let {
      children
    } = _ref3;
    if (variant === variants.ORDERED) return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.OrderedList, {
      className: "ordered"
    }, children);
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.UnorderedList, {
      className: "unordered"
    }, children);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "list-container sia-padding-05-bottom sia-padding-03-right"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-07 sia-margin-01-bottom",
    dangerouslySetInnerHTML: {
      __html: title.replace('<p>', '').replace('</p>', '')
    }
  }), /*#__PURE__*/_react.default.createElement(Wrapper, null, items.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(Item, _extends({
      key: index
    }, item, {
      level: 0,
      variant: variant
    }));
  })));
};
List.propTypes = {
  items: _propTypes.default.array.isRequired,
  title: _propTypes.default.string.isRequired,
  variant: _propTypes.default.oneOf(Object.values(variants))
};
List.defaultProps = {};
var _default = exports.default = List;